<template>
  <div class="notice">
    <div class="notice-content w1200">
      <div class="notice-center left">
        <h2 class="clum">
          <i class="icon"></i>
          <span>公告</span>
          <span class="more" @click="enterNewsList()">更多>></span>
        </h2>
        <div class="left-item" v-for="(item,index) in list" :key="index" @click="enterDetaisl(item)">
          <div class="cover">
            <img :src="item.conver" alt="">
          </div>
          <div class="item-content">
            <p class="title">{{item.title}}</p>
            <p class="subtitle">{{item.subTitle}}</p>
            <p class="time">{{formatDate(item.issueTime,true)}}</p>
          </div>
          <span>查看详情</span>
        </div>
        <!-- <p class="dec" v-for="(item,index) in list" :key="index">{{item.title}}</p> -->
      </div>
      <div class="notice-center right">
        <h2 class="clum">
          <i class="icon"></i>
          <span>活动信息</span>
          <span class="more" @click="enterActionList()">更多>></span>
        </h2>
        <p class="dec" v-for="(item,index) in actionList" :key="index" @click="enterNoticeDetails(item)">
          <span class="action-title">{{item.title}}</span>
          <span class="game-time">{{item.subTitle}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { websitePageNews, websitePageQueryList } from '@/api/association'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'notice',
  data () {
    return {
      loading: true,
      list: [],
      actionList: [],
      pageNum: 1,
      currentPage: 1
    }
  },
  methods: {
    formatDate,
    addNoticeMatchList () {
      let that = this
      if (that.loading === true) {
        console.log(that.loading)
        websitePageNews({ pageNo: that.pageNum, pageSize: 3, assoId: localStorage.getItem('assoId'), type: 2 }).then(res => {
          if (res.data.status === 0) {
            that.list = res.data.data.list
            that.loading = true
          }
        })
      }
    },
    websitePageQueryList () {
      let that = this
      websitePageQueryList({ pageNo: that.currentPage, pageSize: 5, assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          that.actionList = res.data.data.list
        }
      })
      // that.loading = true
    },
    enterDetaisl (item) {
      this.$router.push({
        name: `NewsDetails`,
        params: { newsId: item.id, type: 2 }
      })
    },
    enterNoticeDetails (item) {
      this.$router.push({
        name: `ActionMsgDetails`,
        params: { id: item.id, info: item }
      })
    },
    enterNewsList (item) {
      this.$router.push({
        name: `NewList`,
        params: { type: 2 }
      })
    },
    enterActionList () {
      this.$router.push({
        name: `ActionMsgList`,
        params: { type: 2 }
      })
    }
  },
  mounted () {

  },
  created () {
    this.addNoticeMatchList()
    this.websitePageQueryList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .notice{
    width: 100%;
    background-color: #3376c4;
  }
  .notice-content{
    overflow:hidden;
    padding:40px 64px;
  }
  .notice-center{
    width:484px;
    height:396px;
    background: url(../../../../static/images/gonggao_bg.png) 0px 0px no-repeat;
    background-size: cover;
    padding:20px;
    box-sizing: border-box;
  }
  .left{
    float:left;
  }
  .right{
    float:right;
  }
  .left-item {
    /* margin: 10px 0px; */
    display: flex;
    padding: 10px 10px;
    justify-content: space-between;
    align-items: center;
    cursor:pointer;
    border-bottom: 1px solid #f3f3f3;
  }
  .left-item:hover{
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    transform: scale(1.02);
  }
  .left-item .cover{
    width: 107px;
    height: 60px;
    margin-right: 10px;
  }
  .left-item .cover img{
    display: block;
    width: 100%;
    height:100%;
  }
  .item-content{
    width:calc(100% - 180px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .left-item p {
    font-size:16px;
    color:#1a1919;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .left-item .title{
    font-size: 16px;
    color:#1a1919;
  }
  .left-item .subtitle{
    font-size: 14px;
    color:#666;
    margin-top:5px;
  }
  .left-item .time{
    font-size: 12px;
    color:#999;
    margin-top:5px;
  }

  .left-item span{
    color: #999;
    font-size: 14px;
  }
  .left-item:last-child {
    border-bottom: 0px;
  }

  .notice-center .clum{
    overflow:hidden;
    margin-bottom: 20px;
  }
  .clum .icon{
    width: 2px;
    height: 17px;
    display:block;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    background-size: 2px 17px;
    background-image: url(../../../../static/images/gonggao_shuxian.png);
    float:left;
  }
  .clum .more{
    float: right;
    color: #409EFF;
    font-size: 14px;
    cursor: pointer;
  }
  .clum span{
    float:left;
    font-size:18px;
    color:#161212;
    font-weight:bold;
    line-height:1;
    margin-left:10px;
  }
  .notice-center .dec{
    color:#1a1919;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor:pointer;
    margin:10px 0px;
    padding:5px 0px;
  }
  .notice-center .dec:hover{
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    transform: scale(1.02);
  }
  .notice-center .dec span{
    display: block;
    overflow: hidden;
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .notice-center .dec span.action-title{
    font-size: 16px;
    color:#666;
    line-height: 20px;
  }
  .notice-center .dec span.game-time{
    font-size: 14px;
    color:#999;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Notice/Notice.vue